import { render, staticRenderFns } from "./wrongList.vue?vue&type=template&id=d1161dd4&scoped=true&"
import script from "./wrongList.vue?vue&type=script&lang=js&"
export * from "./wrongList.vue?vue&type=script&lang=js&"
import style0 from "./wrongList.vue?vue&type=style&index=0&id=d1161dd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1161dd4",
  null
  
)

export default component.exports